/**
 * Statement of cash flows API (Adjustment Cashflow tab).
 */
import {BASE_AUDIT_API, fetchAPI} from '@/services/api';

const base = `${BASE_AUDIT_API}/cashflow`;

export interface CashflowLine {
    code: string;
    section: string;
    label: string;
    indent?: number | null;
    header?: boolean | null;
    total?: boolean | null;
    thisYear?: number | null;
    lastYear?: number | null;
    source?: string | null;
    hideIfZero?: boolean | null;
}

export interface CashflowVO {
    companyId?: number | null;
    annualId?: number | null;
    companyName?: string | null;
    periodFrom?: string | null;
    periodTo?: string | null;
    presentationCurrency?: string | null;
    hideLastYear?: boolean | null;
    varianceThisYear?: number | null;
    varianceLastYear?: number | null;
    lines?: CashflowLine[] | null;
}

export function getCashflow(companyId: number, annualId: number) {
    return fetchAPI<CashflowVO>(`${base}?companyId=${companyId}&annualId=${annualId}`, {
        method: 'GET',
    });
}

/** Save / replace manual Last year amounts (code → amount). */
export function saveCashflowLastYear(
    companyId: number,
    annualId: number,
    amounts: Record<string, number>,
) {
    return fetchAPI<CashflowVO>(`${base}/last-year`, {
        method: 'POST',
        body: JSON.stringify({companyId, annualId, amounts}),
    });
}
